import React from "react"
import Navbar from "@components/layout/Navbar"
import Footer from "@components/layout/Footer"

const Layout = ({ children, transparent }) => {
  return (
    <>
      <Navbar transparent={transparent} />
      <main>{children}</main>
      <Footer />
    </>
  )
}

export default Layout
